import useFeaturePermissionsContext from '@contexts/FeaturePermissionsContext/hook';
import useGroupsContext from '@contexts/GroupsContext/hook';
import { PermissionFilter, permiteProduto } from '@utils/permissionFilter';
import { produtosAlcancados } from '@utils/produtosAlcancados';

/**
 * Tem ALGUMA comunidade em que a pessoa pode isto (§6.3.2).
 *
 * Substitui `useHasProducerProducts` nos relatórios normais. Aquele responde "sou dona ou
 * coprodutora em algum lugar", e por construção diz não para quem entra por grant: o colaborador
 * com `reportBotContacts:view` concedido via ficava com a tela inteira escondida e o item fora do
 * menu, sem nunca chegar ao seletor que já o aceitaria.
 *
 * A conversão é "como condição de EXISTIR, não de esconder": aparece para quem tem a permissão em
 * algum produto, e continua não aparecendo para quem nunca pôde — sem regressão, e com o destino
 * alcançável.
 */
export const useHasProductWithPermission = (filtro: PermissionFilter) => {
  const { groups } = useGroupsContext();
  const { getUserPermissions } = useFeaturePermissionsContext();

  return produtosAlcancados(groups).some((product) =>
    permiteProduto(getUserPermissions, filtro, product.id),
  );
};

/**
 * Os ids das comunidades em que a pessoa pode isto.
 *
 * Mesma regra do `useHasProductWithPermission`, para os pontos que recortam uma LISTA de ids antes
 * de chamar a API em vez de decidir se a tela abre.
 */
export const useProductIdsWithPermission = (filtro: PermissionFilter) => {
  const { groups } = useGroupsContext();
  const { getUserPermissions } = useFeaturePermissionsContext();

  return produtosAlcancados(groups)
    .filter((product) => permiteProduto(getUserPermissions, filtro, product.id))
    .map((product) => product.id);
};
